export enum FieldTypes {
	'text' = 'text',
	'longtext' = 'longtext',
	'richtext' = 'richtext',
	'date' = 'date',
	'time' = 'time',
	'select' = 'select',
	'multiselect' = 'multiselect',
	'dropdown' = 'dropdown',
	'label' = 'label',
	'checkbox' = 'checkbox',
	'radio' = 'radio',
	'file' = 'file',
	'generator' = 'generator',
	'prototype' = 'prototype',
	'instance' = 'instance',
	'widget' = 'widget',
	'schema' = 'schema',
	'symbol' = 'symbol'
}
